import React from "react"
import { Box, Typography, List, ListItem } from "@mui/joy"
import { PersonAvatar } from "../Snippet"

const InfoHeaderCampaignLeadOperator = ({ item }) => {
	const lead = item?.lead ?? {}
	const fullName = `${lead?.firstname ?? ''} ${lead?.lastname ?? ''}`.trim() || lead?.fullName || lead?.companyName || '-'
	const nameTokens = fullName.split(/\s+/).filter(Boolean)
	const avatarFirstName = lead?.firstname || nameTokens[0] || '-'
	const avatarLastName = lead?.lastname || nameTokens.slice(1).join(' ') || nameTokens[0] || '-'
	const email = lead?.email
	const phone = lead?.mobile || lead?.telephone
	const address = [lead?.resStreet, `${lead?.resZip ?? ''} ${lead?.resCity ?? ''}`.trim()]
		.filter(Boolean)
		.join(', ')
	const district = lead?.resDistrict

	return (
		<Box
			className="info-header info-header-person"
			sx={{
				display: 'flex',
				alignItems: 'center',
				borderRadius: 'lg',
				bgcolor: '#FFFFFF',
				p: 3,
				gap: 2
			}}
		>
			<PersonAvatar 
				firstname={avatarFirstName}
				lastname={avatarLastName}
				url={lead?.picture?.url}
				item={lead}
			/>

			<Box sx={{ flex: 1 }}>
				<Typography
					level="h1"
					sx={{
						fontSize: '1.5rem',
						fontWeight: 700,
						color: "var(--customer-800)",
						mb: 1
					}}
				>
					{fullName}
				</Typography>

				<List
					orientation="horizontal"
					sx={{
						gap: 3,
						m: 0,
						p: 0,
						alignItems: 'center'
					}}
				>
					{email && (
						<ListItem sx={{ p: 0 }}>
							<Typography
								level="body-md"
								sx={{
									color: "var(--neutral-600)",
									display: 'flex',
									alignItems: 'center',
									gap: 0.5
								}}
							>
								📧 {email}
							</Typography>
						</ListItem>
					)}

					{phone && (
						<ListItem sx={{ p: 0 }}>
							<Typography
								level="body-md"
								sx={{
									color: "var(--neutral-600)",
									display: 'flex',
									alignItems: 'center',
									gap: 0.5
								}}
							>
								📞 {phone}
							</Typography>
						</ListItem>
					)}

					{(address || district) && (
						<ListItem sx={{ p: 0 }}>
							<Typography
								level="body-md"
								sx={{
									color: "var(--neutral-600)",
									display: 'flex',
									alignItems: 'center',
									gap: 0.5
								}}
							>
								📍 {address}{district ? ` (${district})` : ''}
							</Typography>
						</ListItem>
					)}
				</List>
			</Box>
		</Box>
	)
}

export default InfoHeaderCampaignLeadOperator